module.exports = __webpack_public_path__ + "static/media/velocicaptor.86230e4c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/velocicaptor/velocicaptor.jpg
// module id = 408
// module chunks = 0